/**
 * Plan Service
 * Handles usage tracking for quota-based plan features.
 * Works alongside billing.service.ts which handles subscription/plan tier data.
 */

import { apiClient } from '../lib/api';
import { PlanUsage, PlanFeature } from '../types/plan.types';

export const planService = {
  /**
   * Fetch current usage stats for quota-based features.
   * Returns empty object on failure (safe default — treated as 0 usage).
   */
  getUsage: async (): Promise<PlanUsage> => {
    try {
      const response = await apiClient.get<PlanUsage>('/api/billing/usage');
      return response.data;
    } catch {
      console.warn('[PlanService] Failed to fetch usage, defaulting to empty');
      return {};
    }
  },

  /**
   * Record a usage increment for a quota-based feature.
   * Called after a successful action (e.g., Ask Charti query).
   */
  recordUsage: async (feature: PlanFeature): Promise<void> => {
    try {
      await apiClient.post('/api/billing/usage/record', { feature });
    } catch {
      console.warn('[PlanService] Failed to record usage for', feature);
    }
  },
};
